<template>
  <v-dialog max-width="480" v-model="dialog" persistent>
    <v-card class="text-center">
      <v-card-title class="headline justify-center">
        <div>{{ title }}</div>
      </v-card-title>

      <v-card-text class="mt-4" style="word-break: normal">
        <div>{{ text }}</div>
      </v-card-text>

      <v-col cols="12" align-self="center" justify="center" align="center">
        <v-card flat class="pb-5 buttons">
          <v-btn
            color="primary"
            class="primary-font-color"
            depressed
            block
            large
            @click="onButtonClick()"
          >
            <div>{{ buttonText }}</div>
          </v-btn>
        </v-card>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GenericAlert',
  props: {
    dialog: Boolean,
    title: String,
    text: String,
    buttonText: String,
  },
  methods: {
    onButtonClick() {
      this.dialog = false;
      this.$emit('closed');
    },
  },
};
</script>
